import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getLocaleInURLFormat, formatParsedDate } from 'utils';

import { SectionTitle } from 'components/SectionTitle';
import Icon from 'components/commons/Icon';

import {
  Wrapper,
  NewsWrapper,
  PrimaryNews,
  SecondaryNews,
  SecondaryNewsItem,
  NewsUpdate,
  NewsText,
  AllNews,
} from './styles';

const CurrencyNews = () => {
  const { locale } = useIntl();
  const [first, ...rest] = useSelector(state => state.currency?.newsList || []);

  if (!first) {
    return null;
  }

  return (
    <Wrapper>
      <SectionTitle title="currency.news.mainTitle" none />
      <NewsWrapper>
        <PrimaryNews href={first.link} img={first.img}>
          <NewsUpdate primary>
            {formatParsedDate(first.data, 'DD MMMM YYYY hh:mm')}
          </NewsUpdate>
          <NewsText primary>{first.title}</NewsText>
        </PrimaryNews>

        <SecondaryNews>
          {rest.map(el => (
            <SecondaryNewsItem key={el.id} href={el.link}>
              <NewsUpdate>
                {formatParsedDate(el.date, 'DD MMMM YYYY hh:mm')}
              </NewsUpdate>
              <NewsText>{el.title}</NewsText>
            </SecondaryNewsItem>
          ))}
        </SecondaryNews>
      </NewsWrapper>
      <AllNews
        href={`https://${process.env.APP_DOMAIN}${getLocaleInURLFormat(
          locale
        )}/news/`}
        target="_blank"
      >
        <FormattedMessage id="currency.news.link" />
        <Icon name="vectorStrokeMb" style={{ marginLeft: '10px' }} />
      </AllNews>
    </Wrapper>
  );
};

export default React.memo(CurrencyNews);
